import api from './api'

export default {
  async getAll() {
    const { data } = await api.get('/admin/departments')
    return data
  },

  async getById(id) {
    const { data } = await api.get(`/admin/departments/${id}`)
    return data
  },

  async create(departmentData) {
    const { data } = await api.post('/admin/departments', departmentData)
    return data
  },

  async update(id, departmentData) {
    const { data } = await api.put(`/admin/departments/${id}`, departmentData)
    return data
  },

  async delete(id) {
    const { data } = await api.delete(`/admin/departments/${id}`)
    return data
  }
}

